import { useEffect, useState, ChangeEvent, KeyboardEvent } from 'react'
import { iziplayAuth } from '../tools/api'
import { useNavigate } from 'react-router-dom'
import { Button, TextField } from '@iziplay/ui-kit'

import './login.css'

function Login() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    if (window.localStorage.getItem('token')) {
      navigate('/movies')
    }
  }, [])

  function handleMail(e: ChangeEvent<HTMLInputElement>) {
    setEmail(e.target.value)
  }

  function handlePassword(e: ChangeEvent<HTMLInputElement>) {
    setPassword(e.target.value)
  }

  async function signin() {
    const res = await iziplayAuth()
      .post<{
        token: Iziplay.Token
      }>('/signin/', {
        mail: email,
        password
      })
      .catch(() => {
        setError('Wrong mail or password')
        setPassword('')
      })

    if (!res) {
      return
    }

    setError('')
    window.localStorage.setItem('token', res.data.token)
    navigate('/movies')
  }

  function handleKey(e: KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter') {
      signin()
    }
  }

  return (
    <div className="login">
      <div className="center">
        <div>
          <img src="/img/logo.svg" alt="iziplay" />
        </div>
        <div className="error">{error}</div>
        <TextField
          name="email"
          type="email"
          placeholder="Email"
          value={email}
          onChange={handleMail}
          onKeyPress={handleKey}
        />
        <TextField
          name="password"
          type="password"
          placeholder="Password"
          value={password}
          onChange={handlePassword}
          onKeyPress={handleKey}
        />
        <Button variant="contained" color="primary" fullWidth onClick={signin}>
          Sign in
        </Button>
      </div>
    </div>
  )
}

export default Login
